import { t } from '@/plugins/i18n'
import type { Ref } from 'vue'
import { checkLoginName, getInvitationInfo } from '@/apis/login'
import { isName, isContractName } from '@/plugins/utils'

export const login = (disabled: Ref): any => ({
  nameOrEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) {
          callback(t('用户名不能为空'))
          // } else if (
          //   isName(val) ||
          //   /[\d\w]+\b@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)
          // ) {
        } else {
          callback()
          // callback(t('用户名或邮箱不正确，请重新输入1-10位用户名或邮箱'))
        }
      },
      trigger: 'blur'
    }
  ],

  password: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) {
          callback(t('密码不能为空'))
        } else if (
          // /^[\d\w]+$/.test(val) &&
          val.length >= 6 &&
          val.length <= 32
        ) {
          callback()
        } else {
          callback(t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写'))
        }
      },
      trigger: 'blur'
    }
  ],
  customerEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val) || val === '') {
          callback()
        } else {
          if (val === '') {
            callback()
          } else {
            callback(t('验证码格式不正确，请重新输入'))
          }
        }
      },
      trigger: 'blur'
    }
  ]
})

export const signup = (form: any, disabled: Ref): any => ({
  loginName: [
    { required: true, message: t('用户名不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (isName(val)) {
          checkLoginName(val).then((res: any) => {
            if (res.success) {
              callback()
            } else {
              callback(t('该用户名已被注册'))
            }
          })
        } else {
          callback(t('用户名不可用，请重新设置1-18位用户名不支持标点符号'))
        }
      },
      trigger: 'blur'
    }
  ],
  customerName: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (isContractName(val) || !val) {
          callback()
        } else {
          callback(t('用户名不可用，请重新设置1-18位(特殊字符和标点符号不能使用)'))
        }
      },
      trigger: 'blur'
    }
    // { required: true, message: t('联系人姓名不能为空'), trigger: 'blur' }
  ],
  password: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
        if ((/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*.]{6,32}$/).test(val)) {
          // 字母大小写、数字、特殊字符、6-32(特殊字符可要可不要)
          // 必须包含数字和字母
          callback()
          // if (form.repassword) {
          //   if (val === form.repassword) {
          //   } else {
          //     callback(t('两次密码不一致'))
          //   }
          // } else {
          //   callback()
          // }
        } else {
          callback(
            t('输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写')
          )
        }
      },
      trigger: 'blur'
    }
  ],
  repassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (val === form.password) {
          callback()
        } else {
          callback(t('两次密码不一致'))
        }
      },
      trigger: 'blur'
    }
  ],
  customerEmail: [
    {
      required: true,
      message: t('邮箱格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        // 注册邮箱调整 123@space-green.co.jp
        if (!/[\d\w-]+@[-a-zA-ZA-z0-9]+[.a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: t('验证码格式不正确，请重新输入'),
      trigger: 'change'
    },
    {
      required: true,
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val) || val === '') {
          callback()
        } else {
          if (val === '') {
            callback()
          } else {
            callback(t('验证码格式不正确，请重新输入'))
          }
        }
        callback()
      },
      trigger: ['blur']
    }
  ],
  isagree: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) {
          callback(t('同意以下条款'))
        } else {
          callback()
        }
      },
      trigger: 'change'
    }
  ],
  recommendationEmail: [
    { required: true, message: t('必填'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // 注册邮箱调整 123@space-green.co.jp
        if (!/[\d\w-]+@[-a-zA-ZA-z0-9]+[.a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  customerMobile: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d]{6,20}$/.test(val)) {
          callback()
        } else {
          callback(t('手机号格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ],
  invitationCode: [
    {
      validator: async (rule: any, val: string, callback: any) => {
        if (val === '' || typeof val === 'undefined') callback()
        if (/^[a-zA-Z\d-]{6}$/.test(val)) {
          const resInfo = await getInvitationInfo({
            invitationCode: val
          })
          const data = resInfo.data
          // 请求接口，判断该邀请码是否正确
          if (!data?.stationCode) {
            callback(t('邀请码无效，请重新输入'))
            return
          }
          callback()
        } else {
          callback(t('邀请码无效，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ]
})

export const editInfo = (form: any, disabled: Ref): any => ({
  loginName: [
    { required: true, message: t('用户名不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (isName(val)) {
          callback()
        } else {
          callback(t('用户名不可用，请重新设置1-18位用户名不支持标点符号'))
        }
      },
      trigger: 'blur'
    }
  ],
  customerName: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (isContractName(val) || !val) {
          callback()
        } else {
          callback(t('用户名不可用，请重新设置1-18位(特殊字符和标点符号不能使用)'))
        }
      },
      trigger: 'blur'
    }
    // { required: true, message: t('联系人姓名不能为空'), trigger: 'blur' }
  ],
  password: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
        if ((/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*.]{6,32}$/).test(val)) {
          // 字母大小写、数字、特殊字符、6-32(特殊字符可要可不要)
          // 必须包含数字和字母
          callback()
          // if (form.repassword) {
          //   if (val === form.repassword) {
          //   } else {
          //     callback(t('两次密码不一致'))
          //   }
          // } else {
          //   callback()
          // }
        } else {
          callback(
            t('输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写')
          )
        }
      },
      trigger: 'blur'
    }
  ],
  repassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (val === form.password) {
          callback()
        } else {
          callback(t('两次密码不一致'))
        }
      },
      trigger: 'blur'
    }
  ],
  customerEmail: [
    {
      required: true,
      message: t('邮箱格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        // 注册邮箱调整 123@space-green.co.jp
        if (!/[\d\w-]+@[-a-zA-ZA-z0-9]+[.a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: t('验证码格式不正确，请重新输入'),
      trigger: 'change'
    },
    {
      required: true,
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val) || val === '') {
          callback()
        } else {
          if (val === '') {
            callback()
          } else {
            callback(t('验证码格式不正确，请重新输入'))
          }
        }
        callback()
      },
      trigger: ['blur']
    }
  ],
  isagree: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!val) {
          callback(t('同意以下条款'))
        } else {
          callback()
        }
      },
      trigger: 'change'
    }
  ],
  recommendationEmail: [
    { required: true, message: t('必填'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // 注册邮箱调整 123@space-green.co.jp
        if (!/[\d\w-]+@[-a-zA-ZA-z0-9]+[.a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  // customerMobile: [
  //   {
  //     validator: (rule: any, val: string, callback: any) => {
  //       if (/^[\d]{6,20}$/.test(val)) {
  //         callback()
  //       } else {
  //         callback(t('手机号格式不正确，请重新输入'))
  //       }
  //     },
  //     trigger: 'blur'
  //   }
  // ],
  invitationCode: [
    {
      validator: async (rule: any, val: string, callback: any) => {
        if (val === '' || typeof val === 'undefined') callback()
        if (/^[a-zA-Z\d-]{6}$/.test(val)) {
          const resInfo = await getInvitationInfo({
            invitationCode: val
          })
          const data = resInfo.data
          // 请求接口，判断该邀请码是否正确
          if (!data?.stationCode) {
            callback(t('邀请码无效，请重新输入'))
            return
          }
          callback()
        } else {
          callback(t('邀请码无效，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ]
})

export const findPwd = (form: any, disabled: Ref): any => ({
  customerMobile: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/^[\d]{6,20}$/.test(val)) {
          callback(t('手机号格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  customerEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    // {
    //   required: true,
    //   message: t('验证码格式不正确，请重新输入'),
    //   trigger: ['change']
    // },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: ['blur', 'change']
    }
  ],
  newPassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
        if ((/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*.]{6,32}$/).test(val)) {
          // 字母大小写、数字、特殊字符、6-32(特殊字符可要可不要)
          callback()
        } else {
          callback(
            // t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
            t('输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写')
          )
        }
      },
      trigger: 'blur'
    }
  ],
  repassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (val === form.newPassword) {
          callback()
        } else {
          callback(t('两次密码不一致'))
        }
      },
      trigger: 'blur'
    }
  ]
})

export const changeEmail = (form: any, disabled: Ref): any => ({
  // password: [
  //   { required: true, message: t('密码不能为空'), trigger: 'blur' },
  //   {
  //     validator: (rule: any, val: string, callback: any) => {
  //       if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
  //         callback()
  //       } else {
  //         callback(
  //           t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
  //         )
  //       }
  //     },
  //     trigger: 'blur'
  //   }
  // ],
  password: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' }
  ],
  newCustomerEmail: [
    {
      required: true,
      message: t('邮箱格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  newMobile: [
    {
      required: true,
      message: t('无效内容'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d]{6,20}$/.test(val)) {
          disabled.value = false
          callback()
        } else {
          disabled.value = true
          callback(t('手机号格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: t('验证码格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ]
})

export const setupPwd = (form: any, disabled: Ref): any => ({
  customerEmail: [
    {
      validator: (rule: any, val: string, callback: any) => {
        if (!/[\d\w-]+@([a-zA-ZA-z0-9-]+\.)+[a-z]+/.test(val)) {
          callback(t('邮箱格式不正确，请重新输入'))
          disabled.value = true
        } else {
          callback()
          disabled.value = false
        }
      },
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: t('验证码格式不正确，请重新输入'),
      trigger: 'blur'
    },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ],
  oldPassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' }
    // {
    //   validator: (rule: any, val: string, callback: any) => {
    //     if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
    //       callback()
    //     } else {
    //       callback(
    //         t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
    //       )
    //     }
    //   },
    //   trigger: 'blur'
    // }
  ],
  newPassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        // if (/^[\d\w]+$/.test(val) && val.length >= 6 && val.length <= 32) {
        if ((/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9!@#$%^&*.]{6,32}$/).test(val)) {
          callback()
          // 字母大小写、数字、特殊字符、6-32(特殊字符可要可不要)
        } else {
          callback(
            // t('输入的密码格式不正确，请设置6-32位字母或数字，区分大小写')
            t('输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写')
          )
        }
      },
      trigger: 'blur'
    }
  ],
  repassword: [
    { required: true, message: t('密码不能为空'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (val === form.newPassword) {
          callback()
        } else {
          callback(t('两次密码不一致'))
        }
      },
      trigger: 'blur'
    }
  ]
})

// 提现
export const Withdrawal = (form: any, disabled: Ref): any => ({
  withdrawChannelType: [
    { required: true, message: t('请选择提现渠道'), trigger: 'blur' }
  ],
  bankName: [
    { required: true, message: t('请输入银行名称'), trigger: 'blur' }
  ],
  bankAddress: [
    { required: true, message: t('请输入支店名'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^.{1,20}$/.test(val)) {
          callback()
        } else {
          callback(t('输入的支店名格式不正确，请设置1-20位字符'))
        }
      },
      trigger: 'blur'
    }
  ],
  kzType: [
    { required: true, message: t('请选择口座类别'), trigger: 'blur' }
  ],
  bankNo: [
    { required: true, message: t('请输入银行账号'), trigger: 'blur' }
  ],
  beneficiaryName: [
    { required: true, message: t('请输入收款人名称'), trigger: 'blur' }
  ],
  withdrawAmountRmb: [
    { required: true, message: t('请输入提现金额'), trigger: 'blur' }
  ],
  emailCode: [
    { required: true, message: t('请输入验证码'), trigger: 'blur' },
    {
      validator: (rule: any, val: string, callback: any) => {
        if (/^[\d\w]{4,8}$/.test(val)) {
          callback()
        } else {
          callback(t('验证码格式不正确，请重新输入'))
        }
      },
      trigger: 'blur'
    }
  ]
})
